import { StandardEvents } from '@shopify/events';

const AWARE_CART_ITEM_ADDED_EVENT = 'aware:cart:item-added';
const TOAST_VISIBLE_DURATION = 1000;
const TOAST_EXIT_DURATION = 180;

/**
 * Shows one global confirmation toast after an add-to-cart request succeeds.
 * Theme product forms publish Shopify's cart lines update event; custom Aware
 * cart recommendations publish AWARE_CART_ITEM_ADDED_EVENT after their direct
 * Ajax request succeeds.
 */
class AwareCartToast extends HTMLElement {
  /** @type {number | undefined} */
  #hideTimer;

  /** @type {number | undefined} */
  #concealTimer;

  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);
    document.addEventListener(AWARE_CART_ITEM_ADDED_EVENT, this.#handleAwareCartItemAdded);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);
    document.removeEventListener(AWARE_CART_ITEM_ADDED_EVENT, this.#handleAwareCartItemAdded);
    window.clearTimeout(this.#hideTimer);
    window.clearTimeout(this.#concealTimer);
  }

  /** @param {import('@shopify/events').CartLinesUpdateEvent} event */
  #handleCartLinesUpdate = (event) => {
    if (event.action !== 'add' || !event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.didError) this.show();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[aware-cart-toast] Add-to-cart request failed:', error);
      });
  };

  #handleAwareCartItemAdded = () => {
    this.show();
  };

  show() {
    window.clearTimeout(this.#hideTimer);
    window.clearTimeout(this.#concealTimer);

    this.hidden = false;

    requestAnimationFrame(() => {
      this.setAttribute('open', '');
      this.#hideTimer = window.setTimeout(this.hide, TOAST_VISIBLE_DURATION);
    });
  }

  hide = () => {
    this.removeAttribute('open');
    this.#concealTimer = window.setTimeout(() => {
      if (!this.hasAttribute('open')) this.hidden = true;
    }, TOAST_EXIT_DURATION);
  };
}

if (!customElements.get('aware-cart-toast')) {
  customElements.define('aware-cart-toast', AwareCartToast);
}
